export namespace TdisConstants {
  export enum TypeOfClient {
    TRADER = "TRADER",
    FREIGHT_FORWARDER = "FREIGHT_FORWARDER",
    SPOT_CLIENT = "SPOT_CLIENT",
  }

  export enum MeansOfConveyance {
    VESSEL = "VESSEL",
    AIR = "AIR",
    RAIL = "RAIL",
    ROAD = "ROAD",
    SEA = 'SEA'
  }

  export enum Product {
    MARINE_CARGO_INSURANCE = "MARINE_CARGO_INSURANCE",
    SELLERS_INTEREST = "SELLERS_INTEREST",
    BUYERS_INTEREST = "BUYERS_INTEREST",
  }

  export enum CertificateRequestScopeStatus {
    PENDING_CERTIFICATE_CONFIRMATION = "PENDING_CERTIFICATE_CONFIRMATION",
    CERTIFICATE = "CERTIFICATE",
    VESSEL_TBA = "VESSEL_TBA",
    CERTIFICATE_CANCELLED = "CERTIFICATE_CANCELLED",
    PENDING_CERTIFICATE_UPLOAD = "PENDING_CERTIFICATE_UPLOAD",
    REJECTED = "REJECTED",
    PENDING_MANUAL_APPROVAL = "PENDING_MANUAL_APPROVAL",
    EXPIRED = "EXPIRED",
    LC_PENDING_APPROVAL = "LC_PENDING_APPROVAL",
    REQUEST_REVISED = "REQUEST_REVISED",
    PENDING_APPROVAL = "PENDING_APPROVAL",
    REQUEST_FAILED = 'REQUEST_FAILED',
    APPROVED = 'APPROVED',
    PENDING_UPLOAD = 'PENDING_UPLOAD',
    DECLARED = 'DECLARED',
    CANCELLED = 'CANCELLED',
    REQUEST_IN_PROCESS = 'REQUEST_IN_PROCESS',
    BULK_DECLARATION = 'BULK_DECLARATION',
    STORAGE = 'STORAGE',
    PENDING = 'PENDING',
    UNDER_REVISION = 'UNDER_REVISION',
    PENDING_CERTIFICATE_CANCELLATION = "PENDING_CERTIFICATE_CANCELLATION",
    PENDING_INSURER_APPROVAL = "PENDING_INSURER_APPROVAL",
    INSURER_APPROVED = 'INSURER_APPROVED',
    INSURER_REMARKED = 'INSURER_REMARKED'

  }

  export enum RebateType {
    NET_PREMIUM_REBATE = 'NET_PREMIUM_REBATE',
    WAR_STRIKE_PREMIUM_REBATE = 'WAR_STRIKE_PREMIUM_REBATE',
    OVERAGE_PREMIUM_REBATE = 'OVERAGE_PREMIUM_REBATE',
    EXTENSION_PREMIUM_REBATE = 'EXTENSION_PREMIUM_REBATE',
    PRE_SUB_RULE_REBATE = 'PRE_SUB_RULE_REBATE',
    POST_SUB_RULE_REBATE = 'POST_SUB_RULE_REBATE',
    TAX_REBATE = 'TAX_REBATE',
    STORAGE_PREMIUM_REBATE = 'STORAGE_PREMIUM_REBATE'
  }

  export enum ProductName {
    MCI = 'MARINE CARGO INSURANCE',
    SI = 'SELLERS INTEREST',
    BI = 'BUYERS INTEREST'
  }

  export enum IncoTerms {
    CIF = 'CIF',
    FOB = 'FOB',
    CFR = 'CFR',
    FAS = 'FAS',
    EXW = 'EXW',
    FCA = 'FCA',
    CPT = 'CPT',
    CIP = 'CIP',
    DAP = 'DAP',
    DPU = 'DPU',
    DDP = 'DDP',
    DAT = 'DAT'
  }

  export enum ClientAddressOrLossPayee {
    HOLDER = 'HOLDER',
    ORDER = 'ORDER',
    LOSSPAYEE = 'LOSSPAYEE',
    CLIENT = 'CLIENT',
    MOVERS_ASSURED = 'MOVERS_ASSURED'
  }

  export enum PartyToBeInsured {
    TO_ORDER = 'To Order',
    THE_HOLDER = 'The Holder',
  }

  export enum ClientType {
    Seller = 'Seller',
    Buyer = 'Buyer',
    Owner = 'Owner'
  }

  export enum VesselName {
    FIRST_CLASS_VESSEL = 'FIRST CLASS VESSEL'
  }

  export enum MocName {
    Vessel = 'Vessel',
    Road = 'Road',
    Rail = 'Rail',
    Air = 'Air',
    Sea = 'Sea'
  }

  export enum RebateDisplayName {
    Net_Premium_Rebate = 'Net Premium Rebate',
    War_Strike_Premium_Rebate = 'War Strike Premium Rebate',
    Overage_Premium_Rebate = 'Overage Premium Rebate',
    Extension_Premium_Rebate = 'Extension Premium Rebate',
    Pre_Sub_Rule_Rebate = 'Pre Sub Rule Rebate',
    Post_Sub_Rule_Rebate = 'Post Sub Rule Rebate',
    Storage_Premium_Rebate = 'Storage Premium Rebate',
    Tax_Rebate = 'Tax Rebate'
  }

  export enum ActiveStatus {
    ACTIVE = "ACTIVE",
    IN_ACTIVE = "IN_ACTIVE"
  }

  export enum LineOfBusiness {
    MARINE = 'MARINE',
    MOVERS = 'MOVERS'
  }

  export enum ProductNameHeader {
    Sellers_Interest = 'Sellers Interest',
    Buyers_Interest = 'Buyers Interest'
  }

  export enum TypeOfRequest {
    SPECIFIC = 'SPECIFIC',
    OPEN = 'OPEN',
    GENERIC = 'GENERIC',
  }

  export enum RateType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    PREMIUM = 'PREMIUM'
  }

  export enum KindOfCover {
    ALL_RISK_COVER = "All Risk Cover",
    WAR_COVER = "War Cover"
  }


}
